<p-toast position="top-right"></p-toast>

<div class="ssr" [class.ssr--loading]="loading">
  <div *ngIf="loading" class="ssr-loader" aria-hidden="true">
    <p-progressSpinner [style]="{width: '36px', height: '36px'}"
      styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
      animationDuration=".5s"></p-progressSpinner>
  </div>

  <div class="ssr-header">
    <h2 class="ssr-title">{{ setLabel('activityLogsLabel') }}</h2>
  </div>

  <div class="ssr-filters">
    <div class="ssr-filter-group">
      <span class="ssr-filter-label">{{ setLabel('searchByMembershipIDLabel') }}</span>
      <input class="ssr-search" [(ngModel)]="searchValue" autocomplete="off"
        [placeholder]="setLabel('searchPlaceholderLabel')" type="number" name="searchValue"
        (keyup)="searchLocal(searchValue)">
    </div>
    <div class="ssr-filter-group">
      <span class="ssr-filter-label">{{ setLabel('activityTypeLabel') }}</span>
      <p-dropdown [options]="activityTypeOptions" [placeholder]="setLabel('selectPlaceholderLabel')"
        name="selectActivityType" [(ngModel)]="activityTypeValue" (ngModelChange)="getActivityLogs()"
        styleClass="ssr-dd" panelStyleClass="ssr-dd-panel" appendTo="body"></p-dropdown>
    </div>
    <div class="ssr-filter-group">
      <span class="ssr-filter-label">{{ setLabel('activityByLabel') }}</span>
      <p-dropdown [options]="activityByOptions" [placeholder]="setLabel('selectPlaceholderLabel')"
        name="selectUser" [(ngModel)]="activityByValue" (ngModelChange)="getActivityLogs()"
        styleClass="ssr-dd" panelStyleClass="ssr-dd-panel" appendTo="body"></p-dropdown>
    </div>
    <div class="ssr-filter-group">
      <span class="ssr-filter-label">{{ setLabel('fromLabel') }}</span>
      <p-calendar styleClass="ssr-cal" [yearNavigator]="true" yearRange="1950:2040"
        [monthNavigator]="true" [(ngModel)]="from"
        [placeholder]="setLabel('fromDatePlaceholderLabel')" name="fromDate"
        dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"
        (onSelect)="getActivityLogs()"></p-calendar>
    </div>
    <div class="ssr-filter-group">
      <span class="ssr-filter-label">{{ setLabel('toLabel') }}</span>
      <p-calendar styleClass="ssr-cal" [yearNavigator]="true" yearRange="1950:2040"
        [monthNavigator]="true" [(ngModel)]="to"
        [placeholder]="setLabel('toDatePlaceholderLabel')" name="toDate"
        dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"
        (onSelect)="getActivityLogs()"></p-calendar>
    </div>
    <div class="ssr-actions">
      <button type="button" class="ssr-btn" (click)="resetFilter()" [disabled]="loading">
        <i class="pi pi-times" aria-hidden="true"></i>
        <span>Clear</span>
      </button>
      <button *ngIf="userRole?.name === 'Admin' || userRole?.name === 'Super Admin'"
        type="button" class="ssr-btn ssr-btn--export"
        (click)="ExportData(requests, 'Activity_Logs_Report')"
        [disabled]="loading || !requests?.length"
        [pTooltip]="setLabel('exportTooltipLabel')" tooltipPosition="top">
        <i class="pi pi-download" aria-hidden="true"></i>
        <span>Export</span>
      </button>
    </div>
  </div>

  <div class="ssr-table-card">
    <p-table #dt [value]="requests" dataKey="id" [rowHover]="true" [rows]="100"
      [showCurrentPageReport]="true" [loading]="loading" [paginator]="true" [responsive]="true"
      currentPageReportTemplate="There are {{requests?.length}} records" [filterDelay]="0"
      [globalFilterFields]="['name','country.name','representative.name','status']"
      styleClass="ssr-table" class="p-table-tecfolk-fix">

      <ng-template pTemplate="header">
        <tr>
          <th>{{ setLabel('activityDateLabel') }}</th>
          <th>{{ setLabel('activityTypeLabel') }}</th>
          <th>{{ setLabel('activityByLabel') }}</th>
          <th>{{ setLabel('initiatedFromLabel') }}</th>
          <th>{{ setLabel('membershipNoLabel') }}</th>
          <th>{{ setLabel('subjectLabel') }}</th>
          <th>{{ setLabel('scopeLabel') }}</th>
          <th>{{ setLabel('oldValueLabel') }}</th>
          <th>{{ setLabel('newValueLabel') }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-requestor>
        <tr class="p-selectable-row">
          <td [attr.data-label]="setLabel('activityDateLabel')">
            {{ requestor?.createdDateNow | date: 'EEE MMM dd yyyy HH:mm:ss' }}
          </td>
          <td [attr.data-label]="setLabel('activityTypeLabel')">
            <span>{{ requestor.activityType }},</span>
            <ng-container *ngFor="let updatedValue of requestor.updatedValues; let last = last">
              <ng-container *ngIf="!isExcludedActivityType(updatedValue.subjectType)">
                {{ updatedValue.subjectType }}
                <span *ngIf="!last">, </span>
              </ng-container>
            </ng-container>
          </td>
          <td [attr.data-label]="setLabel('activityByLabel')">{{ requestor.activityBy }}</td>
          <td [attr.data-label]="setLabel('initiatedFromLabel')">{{ requestor.initiatedFrom }}</td>
          <td [attr.data-label]="setLabel('membershipNoLabel')">{{ requestor.entitiyTagNumber }}</td>
          <td [attr.data-label]="setLabel('subjectLabel')">{{ requestor.entitiyName }}</td>
          <td [attr.data-label]="setLabel('scopeLabel')">{{ requestor.scope }}</td>
          <td [attr.data-label]="setLabel('oldValueLabel')">
            <!-- Format old values for Update Package without date formatting -->
            <ng-container *ngIf="requestor.activityType === 'Update Package'">
              <ng-container *ngIf="formatOldValuesForPackage(requestor) as formattedOldValues">
                <span *ngFor="let value of formattedOldValues.split(';')">
                  {{ value.trim() }}<br />
                </span>
              </ng-container>
            </ng-container>
            <!-- Format old values for other activity types with date formatting -->
            <ng-container *ngIf="requestor.activityType !== 'Update Package'">
              <ng-container *ngIf="formatOldValues(requestor) as formattedNewValues">
                <span *ngFor="let value of formattedNewValues.split(';')">
                  {{ value.trim() }}<br />
                </span>
              </ng-container>
            </ng-container>
            <span *ngIf="requestor.activityType === 'Member Settings'">{{ requestor.oldValue | date: 'EEE MMM dd yyyy' }}</span>
            <span *ngIf="requestor.activityType === 'Add Fee'">{{ requestor.oldValue | date: 'EEE MMM dd yyyy' }}</span>
            <span *ngIf="requestor.activityType === 'Collect Fee'">{{ requestor.oldValue | date: 'EEE MMM dd yyyy' }}</span>
            <span *ngIf="requestor.activityType === 'Freeze'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'DeFreeze'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'Deactivate'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'Activate'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'Delete Fee'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'Delete Subscription Fee'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'Deleted Petty Cash'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'POS'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'Update Invoice Date'">{{ requestor.oldValue | date: 'EEE MMM dd yyyy HH:mm' }}</span>
            <span *ngIf="requestor.activityType === 'Reschedule Trainer Session'">{{ requestor.oldValue }}</span>
            <span *ngIf="requestor.activityType === 'Cancel Trainer Booking'">{{ requestor.oldValue }}</span>
          </td>
          <td [attr.data-label]="setLabel('newValueLabel')">
            <!-- Format new values for Update Package without date formatting -->
            <ng-container *ngIf="requestor.activityType === 'Update Package'">
              <ng-container *ngIf="formatNewValuesForPackage(requestor) as formattedNewValues">
                <span *ngFor="let value of formattedNewValues.split(';')">
                  {{ value.trim() }}<br />
                </span>
              </ng-container>
            </ng-container>
            <!-- Format new values for other activity types with date formatting -->
            <ng-container *ngIf="requestor.activityType !== 'Update Package'">
              <ng-container *ngIf="formatNewValues(requestor) as formattedNewValues">
                <span *ngFor="let value of formattedNewValues.split(';')">
                  {{ value.trim() }}<br />
                </span>
              </ng-container>
            </ng-container>
            <span *ngIf="requestor.activityType === 'Member Settings'">{{ requestor.newValue | date: 'EEE MMM dd yyyy' }}</span>
            <span *ngIf="requestor.activityType === 'Add Fee'">
              <ng-container *ngIf="getCollectFeeDueDate(requestor) as dueDate; else collectFeeFallback">
                {{ dueDate | date: 'EEE MMM dd yyyy' }}
                <span *ngIf="getCollectFeeFinalAmount(requestor) as amount"> (Final Amount: {{ amount }})</span>
              </ng-container>
              <ng-template #collectFeeFallback>{{ requestor.newValue }}</ng-template>
            </span>
            <span *ngIf="requestor.activityType === 'Collect Fee'">
              <ng-container *ngIf="getCollectFeeDueDate(requestor) as dueDate; else collectFeeFallback">
                {{ dueDate | date: 'EEE MMM dd yyyy' }}
                <span *ngIf="getCollectFeeFinalAmount(requestor) as amount"> (Final Amount: {{ amount }})</span>
              </ng-container>
              <ng-template #collectFeeFallback>{{ requestor.newValue }}</ng-template>
            </span>
            <span *ngIf="requestor.activityType === 'Freeze'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'DeFreeze'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Deactivate'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Activate'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Subscription Fee'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Subscription'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Petty Cash'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'New Package'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Add Trainer Session'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Reschedule Trainer Session'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Trainer Booking'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Visitor Fee'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'POS'">{{ requestor.newValue }}</span>
            <span *ngIf="requestor.activityType === 'Update Invoice Date'">{{ requestor.newValue | date: 'EEE MMM dd yyyy HH:mm' }}</span>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9" class="ssr-empty">{{ setLabel('noActivityLogfoundLabel') }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog [(visible)]="exportConfirmVisible" [modal]="true" [draggable]="false" [resizable]="false"
  [style]="{width: '26rem', maxWidth: '92vw'}">
  <ng-template pTemplate="header">
    <span class="ssr-export-title">Export</span>
  </ng-template>
  <p class="ssr-export-message">Are you sure you want to Export ?</p>
  <ng-template pTemplate="footer">
    <div class="ssr-export-actions">
      <button type="button" class="ssr-btn ssr-btn--cancel" (click)="cancelExport()">Cancel</button>
      <button type="button" class="ssr-btn ssr-btn--confirm" (click)="confirmExport()">
        <i class="pi pi-download" aria-hidden="true"></i>
        <span>Export</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
